namespace Ir.Components.Workbook.Settings.Items.FontSizeSetting {
    export interface IFontSizeSettingParams {
        label?: string;
        value: KnockoutObservable<number>;
    }
    interface IViewModel {
        options: DevExpress.ui.dxNumberBox.Properties;
        label: string;
    }

    interface IParams {
        config: IFontSizeSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        this.label = params.config?.label ?? "Font Size";
        this.options = {
            format: '#px',
            value: params.config.value as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 8,
            max: 200,
            width: 80,
        };
    }
}